module.exports = __webpack_public_path__ + "h5/img/sh.16d9dbe2.png";